export default class DocumentFileTypes {
  static PDF = {
    extensions: [".pdf"],
    mimeType: "application/pdf"
  };

  static PNG = {
    extensions: [".png"],
    mimeType: "image/png"
  };

  static JPG = {
    extensions: [".jpg", ".jpeg"],
    mimeType: "image/jpeg"
  };

  static TIFF = {
    extensions: [".tif", ".tiff"],
    mimeType: "image/tiff"
  };

  static DOC = {
    extensions: [".doc"],
    mimeType: "application/msword"
  };

  static DOCX = {
    extensions: [".docx"],
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  };

  static XLS = {
    extensions: [".xls"],
    mimeType: "application/vnd.ms-excel"
  };

  static XLSX = {
    extensions: [".xlsx"],
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  };
}
